import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CategoryService } from 'src/app/services/category.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  form: FormGroup;
  list = [];
  categories = [];

  constructor(private productService: ProductService, private categoryService: CategoryService) { }

  async ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(null),
      name: new FormControl(null),
      idCategory: new FormControl(null),
      shortDescription: new FormControl(null),
      description: new FormControl(null)
    })

    this.categories = (await this.categoryService.get()).data;
    this.list = (await this.productService.get()).data.map(this.setCategory.bind(this))    
    console.log(this.list)
  }

  setCategory(item) {
    return ({...item, category: this.categories.find(category => category.id === item.idCategory)})
  }

  async save() {
    const {id, ...payload} = this.form.value;
    let created;
    if (this.form.value.id) {
      created = (await this.productService.patch(id, payload));
      this.list = [...this.list.map(item => item.id === id ? this.setCategory.bind(this)(created) : item)]
      return;
    }
    created = await this.productService.post(payload);    
    this.list.push({id: created.id, ...this.setCategory.bind(this)(created)})

  }

  async selectProduct(product) {
    console.log(product.option.value)
    this.form.patchValue(product.option.value);
  }

  async remove(category) {
    await this.productService.remove(category.id);
    this.list = this.list.filter(item => item.id !== category.id);
  }
}
